const E = { SEARCH_AGENT: "SEARCH_AGENT" };
export {
  E as AGENT_TYPES
};
//# sourceMappingURL=AgentType.js.map
